"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateLineOfBusiness = exports.ALTERNATIVE_APP_LOGO = void 0;
const react_1 = __importStar(require("react"));
const AppBar_1 = __importDefault(require("@episource/epi-storybook/lib/components/AppBar"));
const react_router_dom_1 = require("react-router-dom");
const AvatarMenu_1 = require("../AvatarMenu");
const EpiAppSwitchMenu_1 = require("../../EpiAppSwitchMenu");
const GlobalSearch_1 = require("../../GlobalSearch");
const ErrorAlert_1 = require("../../ErrorAlert");
const utils_1 = require("../../../utils");
exports.ALTERNATIVE_APP_LOGO = "Analyst";
const updateLineOfBusiness = (update) => (client, lineOfBusiness) => {
    update({
        client,
        businessLineName: lineOfBusiness?.name,
        businessLineState: lineOfBusiness?.state,
    });
};
exports.updateLineOfBusiness = updateLineOfBusiness;
const AppBarWrapper = ({ picture, metadata, logo, onChange, applications, retryFailedAction, clearError, clientUrl, appId, client, clients, selectedBusinessLineName, selectedBusinessLineState, primaryNavName, navItems, logout, error, resetGlobalSearch, searchResults, search, cache, clientPickerText, }, ref) => {
    const [avatarAnchorEl, setAvatarAnchorEl] = (0, react_1.useState)(null);
    const [appSwitchAnchorEl, setAppSwitchAnchorEl] = react_1.default.useState(null);
    const nameArray = client?.name.split(" ");
    // This is primarily to provide an alternate text / fallback initials to the avatar image.
    // If profile is unavailable at anytime, '--' will handle the race condition
    const avatarInitials = nameArray
        ? nameArray[0].charAt(0).toUpperCase() +
            nameArray[nameArray.length - 1].charAt(0).toUpperCase()
        : "--";
    // TODO: the types for AppBar seem to be incorrect or too strict for what we are using as inputs, this should be corrected in the epi-storybook repo
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(AppBar_1.default, { ref: ref, primaryNavName: primaryNavName, 
            // TODO: types need to be reconciled between this library and epia-storybook.
            // Until the types are reconciled we will have to hard cast the type here
            logo: (react_1.default.createElement(react_router_dom_1.Link, { to: "/" },
                react_1.default.createElement("img", { src: logo, alt: exports.ALTERNATIVE_APP_LOGO }))), avatarPicture: picture, onAvatarClick: (event) => {
                setAvatarAnchorEl(event.currentTarget);
            }, onMenuButtonClick: (event) => {
                setAppSwitchAnchorEl(event.currentTarget);
            }, navItems: navItems, hideActionMenu: true, clients: clients, selectedClient: client, 
            // TODO: We should not need all these details to select a line of business, they belong outside the shared component logic.
            // We may want to refactor AppBar from epi-storybook in the future, or move logic here if it is being sunset.
            // The major piece is removing references to LOB id in epi-storybook. The shared components should just
            // be concerned with what is visible (the client name, and LOB name and state).
            selectedLineOfBusiness: {
                id: client?.businessLines.find(({ name, state }) => name === selectedBusinessLineName &&
                    state === selectedBusinessLineState)?.id,
                name: selectedBusinessLineName,
                state: selectedBusinessLineState,
                clientId: client?.id,
                createdAt: "",
                updatedAt: "",
            }, onClientChange: (0, exports.updateLineOfBusiness)(onChange), clientPickerText: clientPickerText, search: react_1.default.createElement(GlobalSearch_1.GlobalSearch, { clientUrlPrefix: clientUrl, reset: resetGlobalSearch, results: searchResults, search: search }), enableClientPicker: client && (0, utils_1.shouldClientPickerBeVisible)(appId, metadata), avatarInitials: avatarInitials }),
        react_1.default.createElement(EpiAppSwitchMenu_1.EpiAppSwitchMenu, { open: Boolean(appSwitchAnchorEl), close: () => setAppSwitchAnchorEl(null), anchorEl: appSwitchAnchorEl, applications: applications }),
        react_1.default.createElement(AvatarMenu_1.AvatarMenu, { cache: cache, logout: logout, anchorEl: avatarAnchorEl, open: Boolean(avatarAnchorEl), onClose: () => setAvatarAnchorEl(null) }),
        error && (react_1.default.createElement(ErrorAlert_1.ErrorAlert, { error: error, onClose: clearError, retry: retryFailedAction }))));
};
exports.default = react_1.default.forwardRef(AppBarWrapper);
